export default __webpack_public_path__ + "static/media/david_lam.2e9cb805.jpg";